import React from 'react'
import Box from '@mui/material/Box'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'

import { PROFILE_SECURITY_REQUIREMENT_CHIP_SX } from '../constants/profileSecurityConstants'

export default function ProfileSecurityRequirementChip({ isMet, label }) {
  return (
    <Box
      component="span"
      sx={isMet ? PROFILE_SECURITY_REQUIREMENT_CHIP_SX.fulfilled : PROFILE_SECURITY_REQUIREMENT_CHIP_SX.unfulfilled}
    >
      {isMet ? (
        <CheckCircleOutlineRoundedIcon sx={{ fontSize: 14 }} />
      ) : (
        <RadioButtonUncheckedRoundedIcon sx={{ fontSize: 14 }} />
      )}
      {label}
    </Box>
  )
}
